import { styled } from 'baseui';

export default styled('span', ({ $theme }) => {
  return {
    fontStyle: 'normal',
    color: '#97a0c0',
    ...$theme.typography.panelSmall500,
  };
});
